import { Directive, ElementRef, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { IDiagnosticOrder, IWorkflowRequest } from '../../interfaces/diagnostic-order.interface';

@Directive({
  selector: 'gen-aberrations-wrapper'
})
export class AberrationsWrapperUpgradeDirective extends UpgradeComponent {
  @Input() currentOrder: IDiagnosticOrder;
  @Input() currentWorkflow: IWorkflowRequest;
  @Input() revisionId: string;

  constructor(elementRef: ElementRef) {
    super('genAberrationsWrapper', elementRef, null);
  }
}
